<template>
    <control-panel
        :breadcrumbs="breadcrumbsItems"
    >
        <span>{{ title }}</span>

        <template #right>
            <data-gathering-filters>
                <template #append>
                    <v-btn
                        v-if="checkPermission('DATA_SOURCES_GENERATE')"
                        @click="dialogs.generate_bible = true"
                        class="v-btn--primary"
                    >
                        {{ $t('data_gatherings.generate') }}
                    </v-btn>
                </template>
            </data-gathering-filters>

            <!-- generate dialog -->
            <generate-form-dialog
                v-model="dialogs.generate_bible"
            />
        </template>
    </control-panel>
</template>

<script>
import ControlPanel from "@/Shared/ControlPanel";
import GenerateFormDialog from "@/Shared/DathaGatherings/Common/Forms/GenerateFormDialog";
import DataGatheringFilters from "@/Shared/DathaGatherings/Common/Filters/DataGatheringFilters";
import {mapState} from "pinia/dist/pinia";
import {PermissionsStore} from "@/Store/PermissionsStore";
import {mapActions} from "pinia";

export default {
    name: "DataGatheringHeader",

    components: {GenerateFormDialog, ControlPanel, DataGatheringFilters},

    props: {
        title: {
            type: String,
            require: true,
        },

        breadcrumbsItems: {
            type: Array,
            require: true,
        },
    },

    data: () => ({
        dialogs: {
            generate_bible: false,
        },
    }),

    methods: {
        ...mapActions(PermissionsStore, ['checkPermission'])
    },

    computed:{
        ...mapState(PermissionsStore, ['permissions']),
    }
};
</script>
